import React, { Component } from "react";
import { addTradeFormEvent } from "../api/trade.js";
import {
  ACTION_ACCEPT,
  ACTION_APPROVE,
  ACTION_CANCEL,
  ACTION_CANCEL_ACCEPT,
  ACTION_CANCEL_APPROVE,
  ACTION_CANCEL_DECLINE,
  ACTION_CANCEL_OFFER,
  ACTION_CANCEL_REFUSE,
  ACTION_DECLINE,
  ACTION_REFUSE,
  ACTION_REINSTATE,
  ACTION_RETRACT,
  STATUS_APPROVED,
  STATUS_CANCELED_ADM,
  STATUS_CANCELED_EE,
  STATUS_CANCEL_DECLINED,
  STATUS_CANCEL_OFFERED,
  STATUS_CANCEL_REFUSED,
  STATUS_CANCEL_SUBMITTED,
  STATUS_DECLINED,
  STATUS_REFUSED,
  STATUS_RETRACTED,
  STATUS_SUBMITTED,
} from "../util/constants.js";
import { buildCreateTradeFormEventRequestBody } from "../util/tradeFormEventBuilder.js";
import { validateTradeFormEventSequence } from "../util/tradeFormEventValidation";
import ConfirmButton from "./fundamentals/ConfirmButton.jsx";

export class TradeFormActionConfirm extends Component {
  getActionConfirmButtonBasedOnActionSelected(action) {
    switch (action) {
      case ACTION_ACCEPT:
        return this.getActionConfirmButton(STATUS_SUBMITTED);
      case ACTION_DECLINE:
        return this.getActionConfirmButton(STATUS_DECLINED);
      case ACTION_RETRACT:
        return this.getActionConfirmButton(STATUS_RETRACTED);
      case ACTION_APPROVE:
        return this.getActionConfirmButton(STATUS_APPROVED);
      case ACTION_REFUSE:
        return this.getActionConfirmButton(STATUS_REFUSED);
      case ACTION_CANCEL_OFFER:
        return this.getActionConfirmButton(STATUS_CANCEL_OFFERED);
      case ACTION_CANCEL_ACCEPT:
        return this.getActionConfirmButton(STATUS_CANCEL_SUBMITTED);
      case ACTION_CANCEL_DECLINE:
        return this.getActionConfirmButton(STATUS_CANCEL_DECLINED);
      case ACTION_CANCEL:
        return this.getActionConfirmButton(STATUS_CANCELED_ADM);
      case ACTION_CANCEL_APPROVE:
        return this.getActionConfirmButton(STATUS_CANCELED_EE);
      case ACTION_CANCEL_REFUSE:
        return this.getActionConfirmButton(STATUS_CANCEL_REFUSED);
      case ACTION_REINSTATE:
        return this.getActionConfirmButton(STATUS_APPROVED, true);
      default:
        return "uh oh";
    }
  }

  getActionConfirmButton(statusName, isReinstated = false) {
    return (
      <ConfirmButton
        variant="contained"
        color="primary"
        onClick={this.handleActionClicked.bind(this, statusName, isReinstated)}
        isLoading={this.props.isActionLoading}
      >
        Yes
      </ConfirmButton>
    );
  }

  async handleActionClicked(statusName, isReinstated) {
    if (!this.props.isFormValidationSuccess()) {
      return;
    }

    this.props.handleSetIsActionLoading(true);

    var tradeData = this.cleanupReasonData({ ...this.props.trade });

    // Specific Action Types require some different data to be sent...
    if (statusName === STATUS_APPROVED && isReinstated) {
      tradeData.isReinstated = true;
    }

    if (this.containsCannedReason()) {
      tradeData.cannedReason = this.props.cannedReason;
      tradeData.reasonComments = this.props.reasonComments;
    } else if (this.containsReasonCommentsOnly()) {
      tradeData.reasonComments = this.props.reasonComments;
    }

    let payload = JSON.stringify(
      buildCreateTradeFormEventRequestBody(statusName, tradeData, this.props.loggedInUserData)
    );

    let tradeFormEventSequenceValidationErrors = await validateTradeFormEventSequence(
      tradeData.tradeFormId,
      statusName
    );

    if (tradeFormEventSequenceValidationErrors !== "") {
      this.props.handleSetActionErrors(tradeFormEventSequenceValidationErrors);
      this.props.handleSetIsActionLoading(false);
      this.props.handleSetIsActionError(true);
    } else {
      addTradeFormEvent(payload)
        .then((res) => res.json())
        .then((result) => {
          if (result.error) {
            console.error("Error");
            this.props.handleSetActionErrors(result.error);
            this.props.handleSetIsActionLoading(false);
            this.props.handleSetIsActionError(true);
          } else if (result.newTrades.length > 0) {
            this.props.handleClickDialogClose();
            if (this.props.handleSetIsActionSuccess) {
              this.props.handleSetIsActionSuccess(true);
            }
          } else {
            console.error("Unknown response");
          }
        });
    }
  }

  cleanupReasonData(trade) {
    if (trade.cannedReason) {
      delete trade["cannedReason"];
    }
    if (trade.reasonComments) {
      delete trade["reasonComments"];
    }
    return trade;
  }

  containsCannedReason() {
    return this.props.cannedReason !== "";
  }

  containsReasonCommentsOnly() {
    return this.props.cannedReason === "" && this.props.reasonComments !== "";
  }

  render() {
    return (
      <span data-testid="trade-form-action-confirm">
        {this.getActionConfirmButtonBasedOnActionSelected(this.props.actionSelected)}
      </span>
    );
  }
}

export default TradeFormActionConfirm;
